import React, { useState, useEffect } from 'react';
import Select from 'react-select';
import '../../styles/socioeconomicoStyle/FiltrosSocio.css';
import { socioeconomicoService, RegiaoItem } from '../../API/socioeconomicoService';

interface FiltrosSocioProps {
  onFiltrar: (filtros: {
    estado: string;
    municipio: RegiaoItem | null;
  }) => void;
}

const FiltrosSocio: React.FC<FiltrosSocioProps> = ({ onFiltrar }) => {
  const [regiao, setRegiao] = useState<RegiaoItem[]>([]);
  const [estadoSelecionado, setEstadoSelecionado] = useState<string | null>(null);
  const [municipioSelecionado, setMunicipioSelecionado] = useState<RegiaoItem | null>(null);

  useEffect(() => {
    const carregarDados = async () => {
      try {
        const regioes = await socioeconomicoService.getMunicipios();
        setRegiao(regioes);
      } catch (error) {
        console.error("❌ Erro ao carregar municípios:", error);
      }
    };
    carregarDados();
  }, []);

  const estadosUnicos = Array.from(
    new Set(regiao.map(item => item.estado).filter(Boolean))
  );

  // Quando troca de estado, limpa o município selecionado
  useEffect(() => {
    setMunicipioSelecionado(null);
  }, [estadoSelecionado]);

  const handleFiltrar = () => {
    if (!estadoSelecionado || !municipioSelecionado) return;

    onFiltrar({
      estado: estadoSelecionado,
      municipio: municipioSelecionado, // já é um RegiaoItem completo
    });
  };

  return (
    <div className="filtros-card">
      <div className="linha-filtros-grid">
        {/* Select de Estado */}
        <Select
          className="select-filtro"
          placeholder="Selecione o estado"
          options={estadosUnicos.map((estado) => ({ value: estado, label: estado }))}
          value={estadoSelecionado ? { value: estadoSelecionado, label: estadoSelecionado } : null}
          onChange={(option) => setEstadoSelecionado(option ? option.value : null)}
          isClearable
        />

        {/* Select de Município */}
        <Select
          className="select-filtro"
          placeholder="Selecione o município"
          options={regiao
            .filter(item => item.estado === estadoSelecionado)
            .map(item => ({ value: item, label: item.municipio }))} // value = RegiaoItem
          value={
            municipioSelecionado
              ? { value: municipioSelecionado, label: municipioSelecionado.municipio }
              : null
          }
          onChange={(option) => setMunicipioSelecionado(option ? option.value : null)}
          isDisabled={!estadoSelecionado}
          isClearable
        />
      </div>

      {/* Botão embaixo sozinho */}
      <div className="linha-botao">
        <button className="btn-filtrar" onClick={handleFiltrar}>
          Filtrar
        </button>
      </div>
    </div>
  );
};

export default FiltrosSocio;
